export default {
  pillars: {
    sectionTitle: 'Guides et ressources Basetao',
    sectionSubtitle:
      'Des guides pratiques sur les tableurs, l’expédition, le QC, les vendeurs, la sécurité et plus encore.',
    readMore: 'Lire le guide',
    guide: {
      title: 'Le guide complet du tableur Basetao',
      desc: 'Créez et utilisez un tableur Basetao pour organiser liens, vendeurs, QC et expédition.',
    },
    review: {
      title: 'Avis sur Basetao',
      desc: 'Comment fonctionne l’agent Basetao, ses points forts et ses limites.',
    },
    shipping: {
      title: 'Guide des frais d’expédition Basetao',
      desc: 'Comprenez comment les frais d’expédition sont calculés et comment économiser.',
    },
    warehouse: {
      title: 'Guide de l’entrepôt Basetao',
      desc: 'Comment fonctionnent le stockage, la consolidation et le QC à l’entrepôt Basetao.',
    },
    qc: {
      title: 'Guide QC et contrôle qualité Basetao',
      desc: 'Que vérifier sur les photos QC et comment détecter les problèmes tôt.',
    },
    sellers: {
      title: 'Guide des vendeurs de confiance Basetao',
      desc: 'Comment évaluer et choisir des vendeurs fiables pour votre commande.',
    },
    coupons: {
      title: 'Coupons et codes promo Basetao',
      desc: 'Où trouver des réductions et comment les utiliser honnêtement.',
    },
    safety: {
      title: 'Basetao est-il légitime et sûr ?',
      desc: 'Des étapes pratiques pour protéger votre compte, vos paiements et vos achats.',
    },
    vs: {
      title: 'Comparaison Basetao vs Superbuy',
      desc: 'Comparez les frais, les fonctionnalités et le flux de travail de deux agents populaires.',
    },
    beginner: {
      title: 'Guide débutant Basetao',
      desc: 'Un guide simple étape par étape pour votre première commande Basetao.',
    },
  },
};